import { BungalowInfoBottom, BungalowInfoTop } from './styles'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { FormattedMessage, useIntl } from 'react-intl'
import Price from 'components/shared/Price'
import BungalowFeature from 'components/shared/BungalowFeature'
import { bungalowBannerStaticInfo } from 'routes/Accommodation/AccommodationModal/AccommodationModalData'

import iconSmile from 'assets/icons/smile.svg'

interface BungalowInfoBannerProps {
    bannerVersion: string
    bungalowName: string
    maxGuests: number
    doubleBedNo: number
    singleBedNo: number
    sofaNo: number
    kitchenNo: number
    bathroomNo: number
    price: number
}

const BungalowInfoBanner = ({
    bannerVersion,
    bungalowName,
    maxGuests,
    doubleBedNo,
    singleBedNo,
    sofaNo,
    kitchenNo,
    bathroomNo,
    price,
}: BungalowInfoBannerProps) => {
    const { formatMessage } = useIntl()

    const dynamicBungalowData = [
        doubleBedNo,
        singleBedNo,
        sofaNo,
        kitchenNo,
        bathroomNo,
        price,
    ]

    return (
        <Box direction="column">
            <BungalowInfoTop
                pt={32}
                pl={40}
                pr={40}
                bannerVersion={bannerVersion}
            >
                <Text
                    className="max-people"
                    variant="bodyExtraSmall"
                    color={
                        bungalowName.toLowerCase() === 'bungalow duo'
                            ? 'secondary_500'
                            : 'primary_500'
                    }
                >
                    <FormattedMessage
                        id="accommodation.bungalow_modal.quests_limit"
                        defaultMessage="Do <strong>{guests_amount}</strong> gości"
                        description="Please keep the html tags in the translation"
                        values={{
                            guests_amount: maxGuests,
                            strong: (chunks: string[]) => (
                                <Text as="span" variant="heading3">
                                    {chunks}
                                </Text>
                            ),
                        }}
                    />
                </Text>
                <Text variant="heading3" color="secondary_500" pb={32}>
                    {bungalowName}
                </Text>
                <Box gap={8} pb={24} isFullWidth={true}>
                    {bungalowBannerStaticInfo.map((infoLine, index) => (
                        <BungalowFeature
                            key={`${infoLine.highlightedText.id}${index}`}
                            icon={infoLine.icon}
                            iconAlt={infoLine.iconAlt}
                            highlightedText={formatMessage(
                                infoLine.highlightedText
                            )}
                            quantity={dynamicBungalowData[index]}
                            additionalInformation={
                                infoLine.text && formatMessage(infoLine.text)
                            }
                            hasBorderBottom={infoLine.borderBottom}
                        />
                    ))}
                    <BungalowFeature
                        icon={iconSmile}
                        iconAlt="smiling face icon"
                        textColor="grayscale_700"
                        highlightedText={formatMessage({
                            id: 'global.msg.children_3_free',
                            defaultMessage: 'Dzieci (do 3 lat) za darmo!',
                        })}
                    />
                </Box>
            </BungalowInfoTop>
            <BungalowInfoBottom
                direction="column"
                align="flex-end"
                isFullWidth={true}
                pt={16}
                pb={16}
                pr={40}
            >
                <Text variant="bodyExtraSmall" color="grayscale_900">
                    <FormattedMessage
                        id="accommodation.bungalow_modal.one_night_price_label"
                        defaultMessage="Cena za domek za 1 noc"
                    />
                </Text>
                <Price
                    value={price}
                    description={formatMessage({
                        id: 'global.price.label_from',
                        defaultMessage: 'od',
                    })}
                />
            </BungalowInfoBottom>
        </Box>
    )
}

export default BungalowInfoBanner
